<template>
  <v-layout>
    <v-container>
      <v-row>
        <v-col cols="6" sm="6" md="6" justify-center>
          <h1>New Day Study 2.0.6</h1>

          <h1>Copyright (c) 2020 Alimera Sciences Inc.</h1>



          <p>

            *** END USER LICENSE AGREEMENT ***

          </p>



          <p>

            IMPORTANT: PLEASE READ THIS LICENSE CAREFULLY BEFORE USING THIS SOFTWARE.

          </p>



          <h2>1. LICENSE</h2>



          <p>

            By receiving, opening the file package, and/or using New Day Study 2.0.6("Software") containing this software, you agree that this End User User License Agreement(EULA) is a legally binding and valid contract and agree to be bound by it. You agree to abide by the intellectual property laws and all of the terms and conditions of this Agreement.

          </p>



          <p>

            Unless you have a different license agreement signed by Alimera Sciences Inc. your use of New Day Study 2.0.6 indicates your acceptance of this license agreement and warranty.

          </p>



          <p>

            Subject to the terms of this Agreement, Alimera Sciences Inc. grants to you a limited, non-exclusive, non-transferable license, without right to sub-license, to use New Day Study 2.0.6 in accordance with this Agreement and any other written agreement with Alimera Sciences Inc.. Alimera Sciences Inc. does not transfer the title of New Day Study 2.0.6 to you; the license granted to you is not a sale. This agreement is a binding legal agreement between Alimera Sciences Inc. and the purchasers or users of New Day Study 2.0.6.

          </p>



          <p>

            If you do not agree to be bound by this agreement, remove New Day Study 2.0.6 from your computer now and, if applicable, promptly return to Alimera Sciences Inc. by mail any copies of New Day Study 2.0.6 and related documentation and packaging in your possession.

          </p>



          <h2>2. DISTRIBUTION</h2>



          <p>

            New Day Study 2.0.6 and the license herein granted shall not be copied, shared, distributed, re-sold, offered for re-sale, transferred or sub-licensed in whole or in part except that you may make one copy for archive purposes only. For information about redistribution of New Day Study 2.0.6 contact Alimera Sciences Inc..

          </p>



          <h2>3. USER AGREEMENT</h2>



          <h3>3.1 Use</h3>



          <p>

            Your license to use New Day Study 2.0.6 is limited to the number of licenses purchased by you. You shall not allow others to use, copy or evaluate copies of New Day Study 2.0.6.

          </p>



          <h3>3.2 Use Restrictions</h3>



          <p>

            You shall use New Day Study 2.0.6 in compliance with all applicable laws and not for any unlawful purpose. Without limiting the foregoing, use, display or distribution of New Day Study 2.0.6 together with material that is pornographic, racist, vulgar, obscene, defamatory, libelous, abusive, promoting hatred, discriminating or displaying prejudice based on religion, ethnic heritage, race, sexual orientation or age is strictly prohibited.

          </p>



          <p>

            Each licensed copy of New Day Study 2.0.6 may be used on one single computer location by one user. Use of New Day Study 2.0.6 means that you have loaded, installed, or run New Day Study 2.0.6 on a computer or similar device. If you install New Day Study 2.0.6 onto a multi-user platform, server or network, each and every individual user of New Day Study 2.0.6 must be licensed separately.

          </p>



          <p>

            You may make one copy of New Day Study 2.0.6 for backup purposes, providing you only have one copy installed on one computer being used by one person. Other users may not use your copy of New Day Study 2.0.6 . The assignment, sublicense, networking, sale, or distribution of copies of New Day Study 2.0.6 are strictly forbidden without the prior written consent of Alimera Sciences Inc.. It is a violation of this agreement to assign, sell, share, loan, rent, lease, borrow, network or transfer the use of New Day Study 2.0.6. If any person other than yourself uses New Day Study 2.0.6 registered in your name, regardless of whether it is at the same time or different times, then this agreement is being violated and you are responsible for that violation!

          </p>



          <h3>3.3 Copyright Restriction</h3>



          <p>

            This Software contains copyrighted material, trade secrets and other proprietary material. You shall not, and shall not attempt to, modify, reverse engineer, disassemble or decompile New Day Study 2.0.6. Nor can you create any derivative works or other works that are based upon or derived from New Day Study 2.0.6 in whole or in part.

          </p>



          <p>

          Alimera Sciences Inc.'s name, logo and graphics file that represents New Day Study 2.0.6 shall not be used in any way to promote products developed with New Day Study 2.0.6 . Alimera Sciences Inc. retains sole and exclusive ownership of all right, title and interest in and to New Day Study 2.0.6 and all Intellectual Property rights relating thereto.

          </p>



          <p>

          Copyright law and international copyright treaty provisions protect all parts of New Day Study 2.0.6, products and services. No program, code, part, image, audio sample, or text may be copied or used in any way by the user except as intended within the bounds of the single user program. All rights not expressly granted hereunder are reserved for Alimera Sciences Inc..

          </p>



          <h3>3.4 Limitation of Responsibility</h3>



          <p>

            You will indemnify, hold harmless, and defend Alimera Sciences Inc. , its employees, agents and distributors against any and all claims, proceedings, demand and costs resulting from or in any way connected with your use of Alimera Sciences Inc.'s Software.

          </p>



          <p>

            In no event (including, without limitation, in the event of negligence) will Alimera Sciences Inc. , its employees, agents or distributors be liable for any consequential, incidental, indirect, special or punitive damages whatsoever (including, without limitation, damages for loss of profits, loss of use, business interruption, loss of information or data, or pecuniary loss), in connection with or arising out of or related to this Agreement, New Day Study 2.0.6 or the use or inability to use New Day Study 2.0.6 or the furnishing, performance or use of any other matters hereunder whether based upon contract, tort or any other theory including negligence.

          </p>



          <p>

            Alimera Sciences Inc.'s entire liability, without exception, is limited to the customers' reimbursement of the purchase price of the Software (maximum being the lesser of the amount paid by you and the suggested retail price as listed by Alimera Sciences Inc. ) in exchange for the return of the product, all copies, registration papers and manuals, and all materials that constitute a transfer of license from the customer back to Alimera Sciences Inc..

          </p>



          <h3>3.5 Warranties</h3>



          <p>

            Except as expressly stated in writing, Alimera Sciences Inc. makes no representation or warranties in respect of this Software and expressly excludes all other warranties, expressed or implied, oral or written, including, without limitation, any implied warranties of merchantable quality or fitness for a particular purpose.

          </p>



          <h3>3.6 Governing Law</h3>



          <p>

            This Agreement shall be governed by the law of the US applicable therein. You hereby irrevocably attorn and submit to the non-exclusive jurisdiction of the courts of US therefrom. If any provision shall be considered unlawful, void or otherwise unenforceable, then that provision shall be deemed severable from this License and not affect the validity and enforceability of any other provisions.

          </p>



          <h3>3.7 Termination</h3>



          <p>

            Any failure to comply with the terms and conditions of this Agreement will result in automatic and immediate termination of this license. Upon termination of this license granted herein for any reason, you agree to immediately cease use of New Day Study 2.0.6 and destroy all copies of New Day Study 2.0.6 supplied under this Agreement. The financial obligations incurred by you shall survive the expiration or termination of this license.

          </p>



          <h2>4. DISCLAIMER OF WARRANTY</h2>



          <p>

            THIS SOFTWARE AND THE ACCOMPANYING FILES ARE SOLD "AS IS" AND WITHOUT WARRANTIES AS TO PERFORMANCE OR MERCHANTABILITY OR ANY OTHER WARRANTIES WHETHER EXPRESSED OR IMPLIED. THIS DISCLAIMER CONCERNS ALL FILES GENERATED AND EDITED BY New Day Study 2.0.6 AS WELL.

          </p>



          <h2>5. CONSENT OF USE OF DATA</h2>



          <p>

            You agree that Alimera Sciences Inc. may collect and use information gathered in any manner as part of the product support services provided to you, if any, related to New Day Study 2.0.6.Alimera Sciences Inc. may also use this information to provide notices to you which may be of use or interest to you.

          </p>
        </v-col>
      </v-row>
    </v-container>
    <div class="text-center">
      <!-- <v-btn dark color="orange darken-2" @click="snackbar = true">Open Snackbar</v-btn> -->
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        color="error"
        :top="y === 'top'"
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data: () => ({
    snackbar: false,
    text: "REQUEST COMPLETE",
    timeout: 4000,
    y: "top",
    username: "",
    password: "",
    show2: false,
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ]
  }),
  created() {
    //debugger;
    // console.log(process.env.googleExternalLogin);
    // console.log(process.env.NODE_ENV);
  },
  methods: {
    keyupSubmit(e) {
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    submit() {
      //OID10001
      if (this.$refs.form.validate()) {
        console.log("submit");
        const baseURI = this.$store.getters.getBaseUrl + "login";
        this.$http
          .post(baseURI, {
            username: this.username,
            password: this.password,
          })
          .then((result) => {
            this.$store.commit("setLoggedUser", result.data);
            this.$store.commit("setToken", result.data.token);
            console.log(result);

            if (result.data.cp) {
              this.$router.push({ path: "changeMyPassword" });
            } else {
              this.$router.push("/");
            }

            //window.location.href = "/#/";
          })
          .catch((error) => {
            //debugger
            this.text =
              typeof error.response == "undefined"
                ? error
                : error.response.data;
            this.snackbar = true;
            console.log("error " + error);
          });
      }
    },
    resetFields() {
      //debugger
      this.$refs.form.reset();
    },
  },
  mounted() {
    //alert("clear options")
    this.$store.commit("setMenuOptions", []);
  }
};
</script>

<style>
</style>
